import React, { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Importamos iconos de flechas

const ProductShowcase = ({ product }) => {
  if (!product) {
    return <p>Loading...</p>; // Mensaje de carga si no hay datos del producto
  }

  // Lista de imágenes
  const images = product.images || ["https://via.placeholder.com/300"];
  
  // Estado para la imagen principal
  const [currentIndex, setCurrentIndex] = useState(0);

  // Función para cambiar de imagen
  const handleNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <section className="bg-gradient-to-b from-orange-100 to-white py-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Imagen del producto con botones de flechas */}
        <div className="relative text-center">
          <img
            src={images[currentIndex]}
            alt={product.name}
            className="w-full max-w-md mx-auto rounded-lg shadow-md transition-all duration-300"
          />

          {/* Botón de flecha izquierda */}
          {images.length > 1 && (
            <button
              onClick={handlePrevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full shadow-lg hover:bg-gray-600 transition-all"
            >
              <FaArrowLeft size={20} />
            </button>
          )}

          {/* Botón de flecha derecha */}
          {images.length > 1 && (
            <button
              onClick={handleNextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full shadow-lg hover:bg-gray-600 transition-all"
            >
              <FaArrowRight size={20} />
            </button>
          )}

          {/* Miniaturas */}
          <div className="flex mt-4 space-x-2 justify-center">
            {images.slice(0, 4).map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Preview ${index}`}
                className={`w-16 h-16 rounded-lg border cursor-pointer transition-all duration-200 ${
                  currentIndex === index ? "border-4 border-blue-500" : "border-gray-300"
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>

        {/* Detalles del producto */}
        <div>
          <h2 className="text-3xl font-bold mb-2">{product.name || "Product Name"}</h2>
          <div className="flex items-center space-x-2 mb-4">
            <span className="text-yellow-500 text-lg">⭐</span>
            <span className="text-lg">{product.rating || "4.5"} / 5.0</span>
          </div>
          <p className="text-lg line-through text-gray-500">
            ${product.original_price || "0.00"}
          </p>
          <p className="text-4xl font-bold text-red-500 mb-2">
            ${product.price || "0.00"}
          </p>
          <p className="text-green-500 font-semibold">Payment on delivery</p>
          <button className="mt-4 bg-red-500 text-white py-3 px-6 rounded-lg shadow-lg hover:bg-red-600 transition-all">
            BUY NOW
          </button>

          {/* Lista de características */}
          <div className="mt-6">
            <h3 className="font-bold text-xl mb-2">FEATURES</h3>
            <ul className="space-y-2">
              {product.copies?.Features?.Features_list &&
              product.copies.Features.Features_list.length > 0 ? (
                product.copies.Features.Features_list.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <span className="text-green-500 mt-1">✔</span>
                    <span>{feature}</span>
                  </li>
                ))
              ) : (
                <p className="text-gray-500">No features available</p>
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
